import { faClipboardCheck } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
// import { KBLinks } from 'constant';

export const OverviewEmptyState: FC = () => {
  // const isNativeUser = useIsNativeUser();

  return (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faClipboardCheck} />}
        title={<FormattedMessage id="home.empty.title" />}
        message={<FormattedMessage id="home.empty.message" />}
        // secondaryCTA={
        //   <EmptyState.CallToAction.Secondary
        //     href={isNativeUser ? KBLinks.addTask : KBLinks.homeCustomer}
        //     target="_blank"
        //   >
        //     <FormattedMessage id="home.empty.secondary" />
        //   </EmptyState.CallToAction.Secondary>
        // }
      />
    </EmptyStateContainer>
  );
};
